// 从localStorage中读取持久化的状态
const loadState = () => {
  try {
    const serializedState = localStorage.getItem('vuex-base-state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

// 保存状态到localStorage
const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('vuex-base-state', serializedState);
  } catch (err) {
    // 忽略存储错误
  }
};

export default {
  namespaced: true,
  state: {
    language: 0,
    languageVal: 'zh',
    cppath: '/productCenter/bialene',
    fwpath: '/serviceCenter/kit',
    xwpath: '/newsCenter/news',
    ...loadState() // 加载持久化的状态
  },
  mutations: {
    CHANGE_NAV_STATE (state) {
      if (state.language === 1) {
        state.language = 0
        state.languageVal = 'zh'
      } else {
        state.language = 1
        state.languageVal = 'en'
      }
    },
    CHANGE_PATH_STATE (state, newPath) {
      state.cppath = newPath
      saveState(state); // 保存状态
    },
    CHANGE_PATH_FW (state, newPath) {
      state.fwpath = newPath
    },
    CHANGE_PATH_XW (state, newPath) {
      state.xwpath = newPath
    }
  }
}
